import { GetterTree } from 'vuex';
import { ChannelModel } from '@/models/forumAPI/ChannelModel';
import { ChannelState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<ChannelState, RootState> = {
  forumAPIChannelById: (state, channelsGetters) => (channelId: string) => {
    const channel = state.channels[channelId];

    return channel ? new ChannelModel(channel, channelsGetters) : undefined;
  },
  allChannels: (state, channelsGetters) => {
    return Object.values(state.channels).map(
      (channel) => new ChannelModel(channel, channelsGetters),
    );
  },
  getPaginationInfo: (state) => {
    return state.pagination;
  },
};

export default getters;
